/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_CancelInputs */

const en_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const fr_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const es_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const it_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

const nl_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuleren`)
};

const pl_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj`)
};

const fi_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta`)
};

const da_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuller`)
};

const sv_cover_letters_cancel = /** @type {(inputs: Cover_Letters_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avbryt`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Cover_Letters_CancelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_cancel = /** @type {((inputs?: Cover_Letters_CancelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_CancelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_cancel(inputs)
	if (locale === "fr") return fr_cover_letters_cancel(inputs)
	if (locale === "es") return es_cover_letters_cancel(inputs)
	if (locale === "it") return it_cover_letters_cancel(inputs)
	if (locale === "nl") return nl_cover_letters_cancel(inputs)
	if (locale === "pl") return pl_cover_letters_cancel(inputs)
	if (locale === "fi") return fi_cover_letters_cancel(inputs)
	if (locale === "da") return da_cover_letters_cancel(inputs)
	if (locale === "sv") return sv_cover_letters_cancel(inputs)
	return en_cover_letters_cancel(inputs)
});